/* Carrito: añade extras desde la barra de envío gratis y la mantiene al día. */
(function () {
  function refresh() {
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart?section_id=cart-drawer' : '/cart?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('SdUpsell'), old = document.getElementById('SdUpsell');
        if (old && fresh) old.replaceWith(fresh);
        else if (old && !fresh) old.remove();
      }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sd-up-add]'); if (!b) return;
    var item = b.closest('.sd-up__item'), v = item && item.querySelector('.sd-up__var'); if (!v) return;
    b.disabled = true;
    fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +v.value, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
    }).then(function (r) { return r.json(); }).then(function (res) {
      var d = document.querySelector('cart-drawer');
      if (d && d.renderContents && res.sections) { res.id = res.items && res.items[0] ? res.items[0].id : null; d.renderContents(res); }
      else location.reload();
    }).catch(function () { b.disabled = false; });
  });
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 300); });
})();
